import { colorsPalettes } from "@similarweb/styles";
import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { SelectionBanner } from "./components/SelectionBanner";
import { useKeywordListComposerContext } from "./KeywordListComposerContext";
import { KeywordListComposerCreatorFooter } from "./KeywordListComposerCreatorFooter";
import { KeywordListComposerCreatorHeader } from "./KeywordListComposerCreatorHeader";
import { KeywordListComposerCreatorQueryResult } from "./KeywordListComposerCreatorQueryResult";
import { KeywordListComposerCreatorSuggestions } from "./KeywordListComposerCreatorSuggestions";
import { KeywordListComposerInput } from "./KeywordListComposerInput";
import { KeywordListComposerSuggestionsBanner } from "./KeywordListComposerSuggestionsBanner";

export const KeywordListComposerCreator = ({ onCloseConfirm }: { onCloseConfirm: VoidFunction }) => {
    const t = useTranslation();
    const { query, bulkEditMode, keywords } = useKeywordListComposerContext();

    return (
        <Flex
            flexDirection="column"
            width="800px"
            padding="20px 24px 16px"
        >
            <KeywordListComposerCreatorHeader />

            <Flex
                flexDirection="column"
                position="relative"
                height="592px"
                borderRadius="4px"
                border={`1px solid ${colorsPalettes.carbon[100]}`}
                overflow="hidden"
            >
                {bulkEditMode ? <SelectionBanner /> : <KeywordListComposerInput />}
                {(() => {
                    if (keywords.length === 0) {
                        return (
                            <EmptyState
                                title={t("keyword_list_composer.empty_state.title")}
                                subtitle={t("keyword_list_composer.empty_state.subtitle")}
                            />
                        );
                    }

                    if (query.length > 0) {
                        return <KeywordListComposerCreatorQueryResult />;
                    }

                    return <KeywordListComposerCreatorSuggestions />;
                })()}
                <KeywordListComposerSuggestionsBanner />
            </Flex>

            <KeywordListComposerCreatorFooter onClose={onCloseConfirm} />
        </Flex>
    );
};
